<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Background/About_the_Authors';
    let nextLink= '';
    
</script>
<PrevNextSection {prevLink} {nextLink} />
<SectionComponent tag="h1" 
  id="about-the-site-1"
  bind:intersecting={visibleById["about-the-site-1"]}
  onIntersectChange={(visible) => setVisible("about-the-site-1", visible)}
>About the Site</SectionComponent>
<ul>
<li>This site is created with <a href="https://kit.svelte.dev" target="_blank">SvelteKit</a>.</li>
<li>Code blocks are included
using <a href="https://github.com/zakhenry/embedme" target="_blank">EmbedMe</a>.</li>
<li>Syntax highlighting is provided
through <a href="https://mdsvex.com/" target="_blank">mdsvex</a> with styling
from <a href="https://prismjs.com/" target="_blank">Prism</a>,
using the Visual Studio Code themes.</li>
<li>The ‘OOPS’ icon on our 404 page comes
from <a href="https://www.flaticon.com/" title="Flaticon" target="_blank">www.flaticon.com</a>.</li>
<li>The word cloud tree was created using <a href="https://www.wordclouds.com/" target="_blank">www.wordclouds.com</a>.</li>
<li>The terminology was created using an <a href="https://thisdavej.com/copy-table-in-excel-and-paste-as-a-markdown-table/" target="_blank">online tool</a> created by Dave Johnson.</li>
</ul>
<p>All the rest, including any errors, can be attributed to the creators of Freon:<br>
<strong>Jos Warmer</strong> and <strong>Anneke Kleppe</strong> (<a href="https://www.openmodeling.nl" target="_blank">www.openmodeling.nl</a>).</p>


<PrevNextSection {prevLink} {nextLink} />